/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { deviceControllerAddSchedule } from '../fn/device/device-controller-add-schedule';
import { DeviceControllerAddSchedule$Params } from '../fn/device/device-controller-add-schedule';
import { deviceControllerCreate } from '../fn/device/device-controller-create';
import { DeviceControllerCreate$Params } from '../fn/device/device-controller-create';
import { deviceControllerDelete } from '../fn/device/device-controller-delete';
import { DeviceControllerDelete$Params } from '../fn/device/device-controller-delete';
import { deviceControllerDeleteSchedule } from '../fn/device/device-controller-delete-schedule';
import { DeviceControllerDeleteSchedule$Params } from '../fn/device/device-controller-delete-schedule';
import { deviceControllerFindAll } from '../fn/device/device-controller-find-all';
import { DeviceControllerFindAll$Params } from '../fn/device/device-controller-find-all';
import { deviceControllerFindAllByClientId } from '../fn/device/device-controller-find-all-by-client-id';
import { DeviceControllerFindAllByClientId$Params } from '../fn/device/device-controller-find-all-by-client-id';
import { deviceControllerFindById } from '../fn/device/device-controller-find-by-id';
import { DeviceControllerFindById$Params } from '../fn/device/device-controller-find-by-id';
import { deviceControllerFindByMacAddress } from '../fn/device/device-controller-find-by-mac-address';
import { DeviceControllerFindByMacAddress$Params } from '../fn/device/device-controller-find-by-mac-address';
import { deviceControllerFindFloorplanHistory } from '../fn/device/device-controller-find-floorplan-history';
import { DeviceControllerFindFloorplanHistory$Params } from '../fn/device/device-controller-find-floorplan-history';
import { deviceControllerGenerateQrLoginToken } from '../fn/device/device-controller-generate-qr-login-token';
import { DeviceControllerGenerateQrLoginToken$Params } from '../fn/device/device-controller-generate-qr-login-token';
import { deviceControllerGetCountByClientId } from '../fn/device/device-controller-get-count-by-client-id';
import { DeviceControllerGetCountByClientId$Params } from '../fn/device/device-controller-get-count-by-client-id';
import { deviceControllerGetSchedules } from '../fn/device/device-controller-get-schedules';
import { DeviceControllerGetSchedules$Params } from '../fn/device/device-controller-get-schedules';
import { deviceControllerReportUpdateStatus } from '../fn/device/device-controller-report-update-status';
import { DeviceControllerReportUpdateStatus$Params } from '../fn/device/device-controller-report-update-status';
import { deviceControllerRestart } from '../fn/device/device-controller-restart';
import { DeviceControllerRestart$Params } from '../fn/device/device-controller-restart';
import { deviceControllerRunAppUpdate } from '../fn/device/device-controller-run-app-update';
import { DeviceControllerRunAppUpdate$Params } from '../fn/device/device-controller-run-app-update';
import { deviceControllerSearchCursor } from '../fn/device/device-controller-search-cursor';
import { DeviceControllerSearchCursor$Params } from '../fn/device/device-controller-search-cursor';
import { deviceControllerSearchOffset } from '../fn/device/device-controller-search-offset';
import { DeviceControllerSearchOffset$Params } from '../fn/device/device-controller-search-offset';
import { deviceControllerSetSchedule } from '../fn/device/device-controller-set-schedule';
import { DeviceControllerSetSchedule$Params } from '../fn/device/device-controller-set-schedule';
import { deviceControllerUpdate } from '../fn/device/device-controller-update';
import { DeviceControllerUpdate$Params } from '../fn/device/device-controller-update';
import { deviceControllerUpdateAutoUpdatePolicy } from '../fn/device/device-controller-update-auto-update-policy';
import { DeviceControllerUpdateAutoUpdatePolicy$Params } from '../fn/device/device-controller-update-auto-update-policy';
import { deviceControllerUpdateDisplayInfo } from '../fn/device/device-controller-update-display-info';
import { DeviceControllerUpdateDisplayInfo$Params } from '../fn/device/device-controller-update-display-info';
import { DeviceDto } from '../models/device-dto';
import { DeviceFloorplanHistoryDto } from '../models/device-floorplan-history-dto';
import { DeviceLoginTokenDto } from '../models/device-login-token-dto';
import { DeviceScheduleEntryDto } from '../models/device-schedule-entry-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class DeviceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deviceControllerFindAll()` */
  static readonly DeviceControllerFindAllPath = '/api/device';

  /**
   * 기기 전체 조회.
   *
   * 기기 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerFindAll$Response(params?: DeviceControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceDto>>> {
    return deviceControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 전체 조회.
   *
   * 기기 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerFindAll(params?: DeviceControllerFindAll$Params, context?: HttpContext): Observable<Array<DeviceDto>> {
    return this.deviceControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DeviceDto>>): Array<DeviceDto> => r.body)
    );
  }

  /** Path part for operation `deviceControllerGetCountByClientId()` */
  static readonly DeviceControllerGetCountByClientIdPath = '/api/device/count/{clientWorkspaceId}';

  /**
   * 고객사 기기 수 조회.
   *
   * 고객사 ID 기준으로 기기 수를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerGetCountByClientId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerGetCountByClientId$Response(params: DeviceControllerGetCountByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deviceControllerGetCountByClientId(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 기기 수 조회.
   *
   * 고객사 ID 기준으로 기기 수를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerGetCountByClientId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerGetCountByClientId(params: DeviceControllerGetCountByClientId$Params, context?: HttpContext): Observable<number> {
    return this.deviceControllerGetCountByClientId$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `deviceControllerFindAllByClientId()` */
  static readonly DeviceControllerFindAllByClientIdPath = '/api/device/all/{clientWorkspaceId}';

  /**
   * 고객사별 기기 조회.
   *
   * 고객사 ID 기준으로 기기 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerFindAllByClientId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerFindAllByClientId$Response(params: DeviceControllerFindAllByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceDto>>> {
    return deviceControllerFindAllByClientId(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사별 기기 조회.
   *
   * 고객사 ID 기준으로 기기 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerFindAllByClientId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerFindAllByClientId(params: DeviceControllerFindAllByClientId$Params, context?: HttpContext): Observable<Array<DeviceDto>> {
    return this.deviceControllerFindAllByClientId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DeviceDto>>): Array<DeviceDto> => r.body)
    );
  }

  /** Path part for operation `deviceControllerSearchOffset()` */
  static readonly DeviceControllerSearchOffsetPath = '/api/device/search/offset';

  /**
   * 기기 오프셋 검색.
   *
   * 기기를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerSearchOffset$Response(params: DeviceControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return deviceControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 오프셋 검색.
   *
   * 기기를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerSearchOffset(params: DeviceControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.deviceControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerSearchCursor()` */
  static readonly DeviceControllerSearchCursorPath = '/api/device/search/cursor';

  /**
   * 기기 커서 검색.
   *
   * 기기를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerSearchCursor$Response(params: DeviceControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return deviceControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 커서 검색.
   *
   * 기기를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerSearchCursor(params: DeviceControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.deviceControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerFindFloorplanHistory()` */
  static readonly DeviceControllerFindFloorplanHistoryPath = '/api/device/{id}/floorplan-history';

  /**
   * 기기 배치 이력 조회.
   *
   * 기기 배치 이력을 최신순으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerFindFloorplanHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerFindFloorplanHistory$Response(params: DeviceControllerFindFloorplanHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceFloorplanHistoryDto>>> {
    return deviceControllerFindFloorplanHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 배치 이력 조회.
   *
   * 기기 배치 이력을 최신순으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerFindFloorplanHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerFindFloorplanHistory(params: DeviceControllerFindFloorplanHistory$Params, context?: HttpContext): Observable<Array<DeviceFloorplanHistoryDto>> {
    return this.deviceControllerFindFloorplanHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DeviceFloorplanHistoryDto>>): Array<DeviceFloorplanHistoryDto> => r.body)
    );
  }

  /** Path part for operation `deviceControllerFindById()` */
  static readonly DeviceControllerFindByIdPath = '/api/device/{id}';

  /**
   * 기기 상세 조회.
   *
   * 기기 ID 기준으로 상세를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerFindById$Response(params: DeviceControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 상세 조회.
   *
   * 기기 ID 기준으로 상세를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerFindById(params: DeviceControllerFindById$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerFindByMacAddress()` */
  static readonly DeviceControllerFindByMacAddressPath = '/api/device/mac/{macAddress}';

  /**
   * MAC 주소 기준 기기 조회.
   *
   * MAC 주소 기준으로 기기를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerFindByMacAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerFindByMacAddress$Response(params: DeviceControllerFindByMacAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerFindByMacAddress(this.http, this.rootUrl, params, context);
  }

  /**
   * MAC 주소 기준 기기 조회.
   *
   * MAC 주소 기준으로 기기를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerFindByMacAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerFindByMacAddress(params: DeviceControllerFindByMacAddress$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerFindByMacAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerGenerateQrLoginToken()` */
  static readonly DeviceControllerGenerateQrLoginTokenPath = '/api/device/{deviceId}/qr-login-token';

  /**
   * QR 로그인 토큰 생성.
   *
   * 기기용 QR 로그인 토큰을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerGenerateQrLoginToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerGenerateQrLoginToken$Response(params: DeviceControllerGenerateQrLoginToken$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceLoginTokenDto>> {
    return deviceControllerGenerateQrLoginToken(this.http, this.rootUrl, params, context);
  }

  /**
   * QR 로그인 토큰 생성.
   *
   * 기기용 QR 로그인 토큰을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerGenerateQrLoginToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerGenerateQrLoginToken(params: DeviceControllerGenerateQrLoginToken$Params, context?: HttpContext): Observable<DeviceLoginTokenDto> {
    return this.deviceControllerGenerateQrLoginToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceLoginTokenDto>): DeviceLoginTokenDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerRestart()` */
  static readonly DeviceControllerRestartPath = '/api/device/{clientWorkspaceId}/restart/{deviceId}';

  /**
   * 기기 재시작.
   *
   * 기기를 재시작합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerRestart()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerRestart$Response(params: DeviceControllerRestart$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerRestart(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 재시작.
   *
   * 기기를 재시작합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerRestart$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerRestart(params: DeviceControllerRestart$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerRestart$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerCreate()` */
  static readonly DeviceControllerCreatePath = '/api/device/{clientWorkspaceId}';

  /**
   * 기기 생성.
   *
   * 기기를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerCreate$Response(params: DeviceControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 생성.
   *
   * 기기를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerCreate(params: DeviceControllerCreate$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerUpdateDisplayInfo()` */
  static readonly DeviceControllerUpdateDisplayInfoPath = '/api/device/{id}/display-info';

  /**
   * 기기 디스플레이 정보 업데이트.
   *
   * 기기에서 수집한 디스플레이 정보를 서버에 저장합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerUpdateDisplayInfo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerUpdateDisplayInfo$Response(params: DeviceControllerUpdateDisplayInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerUpdateDisplayInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 디스플레이 정보 업데이트.
   *
   * 기기에서 수집한 디스플레이 정보를 서버에 저장합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerUpdateDisplayInfo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerUpdateDisplayInfo(params: DeviceControllerUpdateDisplayInfo$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerUpdateDisplayInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerReportUpdateStatus()` */
  static readonly DeviceControllerReportUpdateStatusPath = '/api/device/{deviceId}/update-report';

  /**
   * 기기 업데이트 상태 보고.
   *
   * Electron 기기가 현재 버전과 업데이트 상태를 서버로 보고합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerReportUpdateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerReportUpdateStatus$Response(params: DeviceControllerReportUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerReportUpdateStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 업데이트 상태 보고.
   *
   * Electron 기기가 현재 버전과 업데이트 상태를 서버로 보고합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerReportUpdateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerReportUpdateStatus(params: DeviceControllerReportUpdateStatus$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerReportUpdateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerDelete()` */
  static readonly DeviceControllerDeletePath = '/api/device/{clientWorkspaceId}/{deviceId}';

  /**
   * 기기 삭제.
   *
   * 기기를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerDelete$Response(params: DeviceControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 삭제.
   *
   * 기기를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerDelete(params: DeviceControllerDelete$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerUpdate()` */
  static readonly DeviceControllerUpdatePath = '/api/device/{clientWorkspaceId}/{deviceId}';

  /**
   * 기기 수정.
   *
   * 기기 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerUpdate$Response(params: DeviceControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 수정.
   *
   * 기기 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerUpdate(params: DeviceControllerUpdate$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerUpdateAutoUpdatePolicy()` */
  static readonly DeviceControllerUpdateAutoUpdatePolicyPath = '/api/device/{clientWorkspaceId}/{deviceId}/auto-update';

  /**
   * 기기 자동 업데이트 정책 수정.
   *
   * 기기별 자동 업데이트 활성화, 채널, polling 시각을 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerUpdateAutoUpdatePolicy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerUpdateAutoUpdatePolicy$Response(params: DeviceControllerUpdateAutoUpdatePolicy$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerUpdateAutoUpdatePolicy(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 자동 업데이트 정책 수정.
   *
   * 기기별 자동 업데이트 활성화, 채널, polling 시각을 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerUpdateAutoUpdatePolicy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerUpdateAutoUpdatePolicy(params: DeviceControllerUpdateAutoUpdatePolicy$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerUpdateAutoUpdatePolicy$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerRunAppUpdate()` */
  static readonly DeviceControllerRunAppUpdatePath = '/api/device/{clientWorkspaceId}/run-app-update/{deviceId}';

  /**
   * 기기 수동 앱 업데이트 실행.
   *
   * 관리자가 기기에 앱 업데이트 확인을 수동으로 트리거합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerRunAppUpdate()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerRunAppUpdate$Response(params: DeviceControllerRunAppUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerRunAppUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 수동 앱 업데이트 실행.
   *
   * 관리자가 기기에 앱 업데이트 확인을 수동으로 트리거합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerRunAppUpdate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerRunAppUpdate(params: DeviceControllerRunAppUpdate$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerRunAppUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerSetSchedule()` */
  static readonly DeviceControllerSetSchedulePath = '/api/device/{clientWorkspaceId}/{deviceId}/schedule';

  /**
   * 기기 스케줄 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerSetSchedule()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerSetSchedule$Response(params: DeviceControllerSetSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
    return deviceControllerSetSchedule(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 스케줄 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerSetSchedule$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerSetSchedule(params: DeviceControllerSetSchedule$Params, context?: HttpContext): Observable<DeviceDto> {
    return this.deviceControllerSetSchedule$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceDto>): DeviceDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerGetSchedules()` */
  static readonly DeviceControllerGetSchedulesPath = '/api/device/{clientWorkspaceId}/{deviceId}/schedules';

  /**
   * 기기 스케줄 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerGetSchedules()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerGetSchedules$Response(params: DeviceControllerGetSchedules$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceScheduleEntryDto>>> {
    return deviceControllerGetSchedules(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 스케줄 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerGetSchedules$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerGetSchedules(params: DeviceControllerGetSchedules$Params, context?: HttpContext): Observable<Array<DeviceScheduleEntryDto>> {
    return this.deviceControllerGetSchedules$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DeviceScheduleEntryDto>>): Array<DeviceScheduleEntryDto> => r.body)
    );
  }

  /** Path part for operation `deviceControllerAddSchedule()` */
  static readonly DeviceControllerAddSchedulePath = '/api/device/{clientWorkspaceId}/{deviceId}/schedules';

  /**
   * 기기 스케줄 추가.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerAddSchedule()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerAddSchedule$Response(params: DeviceControllerAddSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceScheduleEntryDto>> {
    return deviceControllerAddSchedule(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 스케줄 추가.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerAddSchedule$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceControllerAddSchedule(params: DeviceControllerAddSchedule$Params, context?: HttpContext): Observable<DeviceScheduleEntryDto> {
    return this.deviceControllerAddSchedule$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceScheduleEntryDto>): DeviceScheduleEntryDto => r.body)
    );
  }

  /** Path part for operation `deviceControllerDeleteSchedule()` */
  static readonly DeviceControllerDeleteSchedulePath = '/api/device/{clientWorkspaceId}/{deviceId}/schedules/{scheduleId}';

  /**
   * 기기 스케줄 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceControllerDeleteSchedule()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerDeleteSchedule$Response(params: DeviceControllerDeleteSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deviceControllerDeleteSchedule(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 스케줄 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceControllerDeleteSchedule$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceControllerDeleteSchedule(params: DeviceControllerDeleteSchedule$Params, context?: HttpContext): Observable<void> {
    return this.deviceControllerDeleteSchedule$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
